"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Close = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Close"));

// Generated by script, don't edit it please.
var Close = (0, _createSvgIcon["default"])({
  as: _Close["default"],
  ariaLabel: 'close',
  category: 'application',
  displayName: 'Close'
});
var _default = Close;
exports["default"] = _default;
module.exports = exports.default;